import { acceptCookies, rejectCookies } from '../components/cookie';
export default () => {
    document.body.addEventListener('click', (event) => {
        var _a;
        const ROLE = (_a = event.target) === null || _a === void 0 ? void 0 : _a.dataset.role;
        const TARGET = event.target;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'mobile-menu-action':
                {
                    document.body.classList.toggle('overflow');
                    const mobileMenu = document.querySelector('.js-mobile-menu');
                    const header = document.querySelector('.js-site-header');
                    TARGET.classList.toggle('active');
                    header && header.classList.toggle('menu-opened');
                    mobileMenu && mobileMenu.classList.toggle('active');
                }
                break;
            case 'reject-cookie':
                {
                    rejectCookies();
                }
                break;
            case 'accept-cookie':
                {
                    acceptCookies();
                }
                break;
            default:
        }
    });
};
